import { render, staticRenderFns } from "./FieldsTable.vue?vue&type=template&id=b6efc1d4&scoped=true&"
import script from "./FieldsTable.vue?vue&type=script&lang=js&"
export * from "./FieldsTable.vue?vue&type=script&lang=js&"
import style0 from "./FieldsTable.vue?vue&type=style&index=0&id=b6efc1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6efc1d4",
  null
  
)

export default component.exports